<div class="container" data-test="modal-onde-alterar-autorizacao">
    <div class="header">
        <div class="header-icon">
            <i class="material-icons">help_outline</i>
        </div>
        <h2 class="header-title" data-test="titulo-onde-alterar-autorizacao">{{ 'accessApproval.whereToChange.title' | translate }}</h2>
        <button mat-icon-button color="primary" type="button" class="close-button" mat-dialog-close
            [attr.aria-label]="'accessApproval.whereToChange.close' | translate"
            data-test="btn-fechar-x-onde-alterar-autorizacao">
            <i class="material-icons">close</i>
        </button>
    </div>

    <mat-dialog-content class="content">
        <ol class="steps" data-test="lista-passos-onde-alterar-autorizacao">
            <li>{{ 'accessApproval.whereToChange.step1' | translate }}</li>
            <li>{{ 'accessApproval.whereToChange.step2' | translate }}</li>
            <li>{{ 'accessApproval.whereToChange.step3' | translate }}</li>
            <li>{{ 'accessApproval.whereToChange.step4' | translate }}
                <strong class="feature" data-test="texto-funcionalidade-onde-alterar-autorizacao">{{ data.funcionalidade }}</strong>
            </li>
            <li>{{ 'accessApproval.whereToChange.step5' | translate }}</li>
        </ol>
    </mat-dialog-content>

    <div class="actions">
        <button mat-stroked-button color="primary" type="button" mat-dialog-close data-test="btn-fechar-onde-alterar-autorizacao">
            {{ 'accessApproval.whereToChange.close' | translate }}
        </button>
    </div>
</div>
